import { useGetSuppressionStatisticsTotalQuery } from "@tiny/api";
import { useRefreshRegister } from "@tiny/components/src/RefreshProvider";
import { formatNumber } from "@tiny/components/src/utils/formatUtils";

export function useSuppressionStatistics() {
  const { data, refetch, isLoading } = useGetSuppressionStatisticsTotalQuery(
    {}
  );

  useRefreshRegister(async () => {
    await refetch();
  });

  const localSuppressedEmails = formatNumber(data?.totalLocalSuppressed || 0);

  const globalSuppressedEmails = formatNumber(data?.totalGlobalSuppressed || 0);

  const refetchSuppressionStats = async () => {
    await refetch();
  };

  return {
    globalSuppressedEmails,
    localSuppressedEmails,
    isLoading,
    refetchSuppressionStats,
  };
}
